import MySelect from '@/components/selectHtml';
import { CommmonGet } from '@/util/network/api';
import React, { useEffect, useState } from 'react';
import './index.scss';

interface Option {
    label: string;
    value: any;
}

interface SelectAddressProps {
    value?: string;
    onChange?: (value: string) => void;
    required: boolean;
    serveInit?: boolean;
}

const SourceAddre: React.FC<SelectAddressProps> = ({
    value,
    onChange,
    required,
    serveInit = true
}) => {
    const [province, setProvince] = useState(null);
    const [city, setCity] = useState(null);
    const [provincialList, setProvincialList] = useState<Option[]>([]);
    const [cityList, setCityList] = useState<Option[]>([]);
    const [addressInfo, setAddressInfo] = useState<string>('');
    const [addSelectId, setAddSelectId] = useState<string>('');

    useEffect(() => {
        serveInit && getArrList(setProvincialList);
    }, []);

    function getArrList(setArrNmae: any, id?: any) {
        CommmonGet('/area', { id }).then((res: any) => {
            setArrNmae(res?.data || []);
        });
    }

    const handleProvinceChange = async (value: string) => {
        if (province === value) {
            return;
        }
        setCity('');
        setProvince(value || '');
        setAddSelectId(value || '');
        setCityList(value ? await getArrListAsync(value) : []);
    };

    const handleCityChange = async (value: string) => {
        if (city === value) {
            return;
        }
        setCity(value || '');
        setAddSelectId(value || '');
        // setCountyList(value ? await getArrListAsync(value) : []);
    };

    async function getArrListAsync(id: string)  {
        const res: any = await CommmonGet('/area', { id });
        return res?.data || [];
    }

    async function initArrList(value) {
        setProvince(value.slice(0, 2));
        (!cityList || cityList?.length == 0) && value.length >= 2 && setCityList(await getArrListAsync(value.slice(0, 2)));
        // (!countyList || countyList?.length == 0) && value.length >= 4 && setCountyList(await getArrListAsync(value.slice(0, 4)));
        value.length >= 4 && setCity(value.slice(0, 4));
        setAddSelectId(value);
    }

    useEffect(() => {
        if (
            value?.split('~')?.[0]?.length >= 2 &&
            (!province || !city)
        ) {
            initArrList(value.split('~')[0]);
        }
        if (value && splitStringByDelimiter(value, '~') && !addressInfo) {
            setAddressInfo(splitStringByDelimiter(value, '~'));
        }
    }, [value]);
    function splitStringByDelimiter(
        str: string,
        delimiter: any,
        partIndex: number = 3
    ) {
        const parts = str.split(delimiter);

        let result: string = '';
        if (parts.length >= partIndex) {
            result = parts.slice(partIndex - 1).join(delimiter);
        } else {
            result = '';
        }

        return result;
    }

    useEffect(() => {
        const provinceLabel = provincialList?.find(
            ele => ele.value === province
        )?.label;
        const cityLabel = cityList?.find(ele => ele.value === city)?.label || '';

        addSelectId && onChange?.(
            (addSelectId || '') +
            '~' +
            (provinceLabel || '') +
            (cityLabel || '')
        );
    }, [addSelectId, addressInfo]);

    return (
        <div style={{ display: 'flex', width: '240px' }}>
            <span style={{ marginRight: 3 }}>
                <MySelect
                    value={province}
                    onChange={handleProvinceChange}
                    options={provincialList}
                    placeholder="请选择省份"
                    width="115px"
                />
            </span>
            <MySelect
                value={city}
                onChange={handleCityChange}
                options={cityList}
                placeholder="请选择城市"
                disabled={!province}
                width="115px"
            />
        </div>
    );
};

export default SourceAddre;
